import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';
import { EMAIL_TEMPLATES_TYPE } from 'store/system/actions';

const initialState = {};

const emailTemplatesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case EMAIL_TEMPLATES_TYPE.GET_EMAIL_TEMPLATES:
      return payload || state;

    case EMAIL_TEMPLATES_TYPE.ADD_EMAIL_TEMPLATE:
    case EMAIL_TEMPLATES_TYPE.UPDATE_EMAIL_TEMPLATE:
    case EMAIL_TEMPLATES_TYPE.UPDATE_EMAIL_TEMPLATE_INFO:
    case EMAIL_TEMPLATES_TYPE.GET_EMAIL_TEMPLATE_BY_ID:
      return { ...state, [payload.id]: payload };

    case EMAIL_TEMPLATES_TYPE.DELETE_EMAIL_TEMPLATE:
      return _.omit(state, payload);

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default emailTemplatesReducer;
